/**
 * Releasenotes voor de "Wat is er nieuw?"-modal.
 *
 * Bij een volgende release: pas `id` aan (uniek per release, bv. de
 * versienaam of datum) en vervang de secties. Gebruikers die "Niet meer
 * tonen" aanvinkten zien de modal weer zodra het `id` verandert.
 *
 * `platforms` bepaalt waar de modal verschijnt ('web', 'android', 'ios');
 * op native toont hij dan na de eerstvolgende (live) update met dit id.
 */
export const RELEASE_NOTES = {
    id: '2026-06-v2',
    platforms: ['web', 'android', 'ios'],
    title: 'Wat is er nieuw in versie 2.0?',
    intro: 'NovaCheck 2.0 is de grootste update sinds de lancering. Dit zijn de belangrijkste vernieuwingen.',
    link: {
        label: 'Bekijk alle wijzigingen',
        url: 'https://novacheck.nl/release-notes',
    },
    sections: [
        {
            icon: 'palette-outline',
            title: 'Compleet vernieuwd uiterlijk',
            description: 'De hele app heeft een fris, modern ontwerp gekregen met betere leesbaarheid en een rustiger beeld.',
            highlights: [
                'Nieuw lettertype en duidelijkere knoppen, formulieren en kaarten',
                'Verbeterde donkere modus met beter contrast',
                'Overzichtelijkere schermen met compactere informatie',
            ],
        },
        {
            icon: 'table-large',
            title: 'Metingen invoeren als matrix',
            description: 'Metingen vul je nu in één overzicht in: meetpunten als rijen, meettypes als kolommen — net een spreadsheet.',
            highlights: [
                'Snel navigeren met Tab (volgend veld) en Enter (volgende rij)',
                'Meerdere cellen tegelijk selecteren en invullen',
                'De tab Metingen toont nu ook bouwdelen en componenten zonder meting, met knop "+ meting"',
                'Voortgang en filters direct naast de matrix',
            ],
        },
        {
            icon: 'bell-outline',
            title: 'Notificaties opnieuw ontworpen',
            description: 'Het notificatiepaneel is herbouwd: overzichtelijker en op elke pagina bereikbaar via de bel.',
            highlights: [
                'Meldingen gegroepeerd in "Nieuw" en "Eerder" met herkenbare pictogrammen',
                'Alles als gelezen markeren met één knop',
                'Meldingen wegvegen om ze te verwijderen',
            ],
        },
        {
            icon: 'navigation-outline',
            title: 'Logischer navigeren',
            description: 'Teruggaan en formulieren invullen werkt nu zoals je verwacht.',
            highlights: [
                'De terugknop volgt de structuur: van component terug naar het overzicht',
                'Account en Instellingen als aparte, overzichtelijke schermen',
                'Keuzes maken met chips in plaats van lange lijsten',
                'Grotere knoppen en tikgebieden — fijner met werkhandschoenen',
                'Velden blijven bereikbaar terwijl het toetsenbord openstaat',
            ],
        },
        {
            icon: 'camera-outline',
            title: 'Soepeler werken met foto\'s',
            description: 'Foto\'s maken, bijsnijden en bewaren werkt betrouwbaarder dan voorheen.',
            highlights: [
                'Foto-voorbeeld staat altijd goed in beeld, ook op tablets',
                'Vierkant bijsnijden werkt nu consequent',
                'Problemen opgelost waardoor een foto soms verloren ging',
            ],
        },
        {
            icon: 'sync',
            title: 'Synchronisatie zichtbaar en betrouwbaar',
            description: 'Je ziet voortaan duidelijk wanneer er gesynchroniseerd wordt — en je kunt gewoon doorwerken.',
            highlights: [
                'Voortgang in beeld in plaats van een blokkerende popup',
                'Nog niet geüploade foto\'s en documenten zijn beter beschermd',
                'Duidelijke melding als een upload niet lukt',
            ],
        },
        {
            icon: 'rocket-launch-outline',
            title: 'Sneller en stabieler',
            description: 'Onder de motorkap is veel verbeterd, vooral merkbaar bij grote inspecties.',
            highlights: [
                'Vlottere paginawisselingen en soepeler scrollen',
                'Minder haperingen bij inspecties met veel componenten',
                'Tientallen kleine fouten opgelost',
            ],
        },
    ],
};
